export default __webpack_public_path__ + "static/media/faqs.d4962ba8.png";